module.exports = __webpack_public_path__ + "img/bg.90120add.png";